import { Injectable } from '@angular/core';

@Injectable()
export class Domain {

  static bUrl = window.location.protocol + '//' + window.location.hostname;
  baseUrl = window.location.protocol + '//' + window.location.hostname;

  // for local development
  // baseUrl = 'https://dev.bxbdigital.com';
  constructor() { }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/constants/domain.constants.ts